module.exports = __webpack_public_path__ + "img/1.2fe0e4cc.jpg";